import { useState } from "react";
import { CrmProvider, useCrm } from "@/components/crm/CrmContext";
import { CrmTopNav } from "@/components/crm/CrmTopNav";
import { CrmDashboard } from "@/components/crm/CrmDashboard";
import { PeopleView } from "@/components/crm/PeopleView";
import { DealsView } from "@/components/crm/DealsView";
import { TasksView } from "@/components/crm/TasksView";
import { CalendarView } from "@/components/crm/CalendarView";
import { InboxView } from "@/components/crm/InboxView";
import { ReportingView } from "@/components/crm/ReportingView";
import { AutomationsView } from "@/components/crm/AutomationsView";
import { TextingSetup } from "@/components/crm/TextingSetup";
import { PersonDrawer } from "@/components/crm/PersonDrawer";
import { AddPersonDialog } from "@/components/crm/AddPersonDialog";
import { MigrationView } from "@/components/crm/MigrationView";
import { ConnectionsView } from "@/components/crm/ConnectionsView";
import { AgentSitesView } from "@/components/crm/AgentSitesView";
import { CrmGuideWidget } from "@/components/crm/CrmGuideWidget";
import { IntegrationsView } from "@/components/crm/IntegrationsView";

const VIEWS = { dashboard: CrmDashboard, people: PeopleView, deals: DealsView, pipeline: DealsView, tasks: TasksView, calendar: CalendarView, inbox: InboxView, reporting: ReportingView, automations: AutomationsView, texting: TextingSetup, migration: MigrationView, connections: ConnectionsView, integrations: IntegrationsView, agent_sites: AgentSitesView };

const Shell = () => {
  const { params, isOwner } = useCrm();
  const [adding, setAdding] = useState(false);
  const requested = params.get("view") || "people";
  const view = !isOwner && ["reporting", "migration"].includes(requested) ? "people" : VIEWS[requested] ? requested : "people";
  const View = VIEWS[view];
  return (
    <div className="crm flex h-screen flex-col overflow-hidden" data-testid="crm-page">
      <CrmTopNav view={view} onAdd={() => setAdding(true)} />
      <main className="crm-scroll min-h-0 flex-1 overflow-y-auto" data-testid={`crm-view-${view}`}><View onAdd={() => setAdding(true)} /></main>
      <PersonDrawer />
      <CrmGuideWidget view={view} />
      <AddPersonDialog open={adding} onOpenChange={setAdding} />
    </div>
  );
};

export default function CRMPage() {
  return <CrmProvider><Shell /></CrmProvider>;
}
